// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"e4a21aed","453":"28d41b47"}[chunkId] + ".chunk.js";
};